import React from 'react'

//Header
export const Header = () => {
  return (
    <header className='header'>New Releases
      <div className='hairline'></div>
    </header>
  )
}